<template>
  <Tooltip
    id="global-tooltip"
    data-cy="global-tooltip"
    :variant="toast.variant"
    :show="!!toast.message"
    :delay="toast.delay"
    @close="closeToast"
  >
    <span>{{ toast.message }}</span
    >&nbsp;
    <span v-if="toast.redirectLink && toast.linkText"
      ><a :href="toast.redirectLink">{{ toast.linkText }}</a
      >.</span
    >
    <br />
    <!-- Toast message id -->
    <!--
    <br v-if="toast.uniqueId" />
        <span v-if="toast.uniqueId && toast.uniqueId !== ''">{{
          toast.uniqueId
        }}</span> 
    -->
  </Tooltip>
</template>
<script setup lang="ts">
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { Ref, computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import Tooltip from "./tooltip.vue";
import store from "@/store";

const toast: Ref<IToastMessage> = ref({} as IToastMessage);

const activeCallApi = computed(() => store.state.User.activeCallApi);

watch(
  () => activeCallApi.value,
  (newValue) => {
    if (!newValue) {
      closeToast();
    }
  },
);

const watchEventToastMessage = () => {
  EventEmitter.on(
    EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE,
    async (data: any) => {
      const activeCallApi = store.state.User.activeCallApi;
      if (
        (!activeCallApi && data.variant === ToastVariant.ERROR) ||
        !data.message
      ) {
        return;
      }
      if (toast.value.message !== "") {
        closeToast();
        await new Promise((resolve) => setTimeout(resolve, 200));
      }

      data.message && (toast.value.message = ref(data.message));
      data.variant && (toast.value.variant = ref(data.variant));
      data.iconSrc && (toast.value.iconSrc = ref(data.iconSrc));
      data.delay && (toast.value.delay = ref(data.delay));
      data.uniqueId && (toast.value.uniqueId = ref(data.uniqueId));
      data.linkText && (toast.value.linkText = ref(data.linkText));
      data.redirectLink && (toast.value.redirectLink = ref(data.redirectLink));
    },
  );
};

const clearWatchEventToastMessage = () => {
  EventEmitter.off(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE);
};

const closeToast = () => {
  toast.value.message = "";
  toast.value.variant = "";
  toast.value.iconSrc = "";
  toast.value.delay = undefined;
  toast.value.uniqueId = "";
  toast.value.linkText = "";
  toast.value.redirectLink = "";
};

onMounted(() => {
  watchEventToastMessage();
});

onBeforeUnmount(() => {
  clearWatchEventToastMessage();
});
</script>
<style scoped>
.tooltip {
  position: fixed;
  /* top: 10px;
  right: 10px; */
  z-index: 9999;
}
</style>
